import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/tokens.css';
import './styles/app.css';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('Could not find #root in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
